// StepFeatures.tsx
import React from "react";
import {Text, Wrap, WrapItem, Button, Flex} from "@chakra-ui/react";

interface StepFeaturesProps {
  features: Record<string, string>;
  selectedFeatures: Record<string, boolean>;
  onToggleFeature: (feature: string) => void;
}

const comingSoonFeatures = [
  "detectAdStops",
  "autoBackgroundSubtitles",
];

const StepFeatures: React.FC<StepFeaturesProps> = (
  {
    features,
    selectedFeatures,
    onToggleFeature,
  }) => {
  return (
    <div className="flex flex-1 w-full items-center justify-center">
      <Wrap
        spacing={8}
        justify="center"
        maxW="700px"
        width="100%"
        mx="auto"
      >
        {Object.keys(features).map((feature: string) => (
          <WrapItem key={feature}>
            <Button
              isDisabled={comingSoonFeatures.includes(feature)}
              opacity={comingSoonFeatures.includes(feature) ? 0.5 : 1}
              variant={selectedFeatures[feature] ? "solid" : "outline"}
              bg={selectedFeatures[feature] ? "brandPurple.500" : "transparent"}
              borderColor={selectedFeatures[feature] ? "transparent" : comingSoonFeatures.includes(feature) ? "n.200" : "brandPurple.500"}
              onClick={() => {
                if (!comingSoonFeatures.includes(feature)) {
                  onToggleFeature(feature);
                }
              }}
              py={6}
              px={4}
              minW="250px"
              height="80px"
              textAlign="center"
              whiteSpace="normal"
              _hover={{
                bg: !comingSoonFeatures.includes(feature) ? "brandPurple.500" : "transparent",
                transform: "scale(1.05)",
                transition: "transform 0.1s"
              }}
              _active={{
                transform: "scale(0.95)",
                transition: "transform 0.1s",
              }}
              transition="transform 0.1s"
            >
              <Flex direction="column" align="center">
                <Text className="text-white">{features[feature]}</Text>
                {comingSoonFeatures.includes(feature) && (
                  <Text fontSize="xs" mt={1} color="gray.300">
                    Coming Soon
                  </Text>
                )}
              </Flex>
            </Button>
          </WrapItem>
        ))}
      </Wrap>
    </div>
  )
    ;
};

export default StepFeatures;